import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import MeetsClass from 'components/Class'
import { userTypes } from 'constants/user'
import { classStore } from 'helpers/room'
import { videoConstraints } from 'helpers/twilio'
import { _roomName, _roomState, _twilioToken } from 'store/selectors/Room'
import { _userInfo, _userType, _userTokens } from 'store/selectors/User'

import ErrorDialog from './components/ErrorDialog/ErrorDialog'
import { VideoProvider } from './components/VideoProvider'
import AppStateProvider, { useAppState } from './state'
import generateConnectionOptions from './utils/generateConnectionOptions/generateConnectionOptions'

const TwilioIndex = () => {
    const { error, setError, settings, dispatchSetting } = useAppState()
    classStore.set('wait')
    const connectionOptions = generateConnectionOptions(settings)
    console.count('TwilioIndex Component')

    const roomName = useSelector(_roomName)
    const roomMode = useSelector(_roomState)
    const twilioToken = useSelector(_twilioToken)
    const userInfo = useSelector(_userInfo)
    const userType = useSelector(_userType)
    const tokens = useSelector(_userTokens)

    useEffect(() => {
        // updating setting for teacher
        if (userType === userTypes.TEACHER) {
            dispatchSetting({
                name: 'video',
                value: {
                    ...videoConstraints.teacher,
                },
            })
        }
    }, [userType])

    const videoProvideProps = {
        token: twilioToken,
        userType,
        options: connectionOptions,
        onError: setError,
        roomName,
        userId: userInfo.user_id,
        roomMode,
        userToken: tokens.access_token,
    }

    return (
        <VideoProvider {...videoProvideProps}>
            <ErrorDialog dismissError={() => setError(null)} error={error} />
            <MeetsClass />
        </VideoProvider>
    )
}

const TwilioApp = () => {
    return (
        <AppStateProvider>
            <TwilioIndex />
        </AppStateProvider>
    )
}
export default TwilioApp
